import { BrowserProvider } from "ethers";
import { api } from "@/lib/api";
import { LOGO_URL } from "@/constants/network";

export const MAX_LOGO_BYTES = 512 * 1024;
export const LOGO_ACCEPT = "image/png,image/jpeg,image/svg+xml";

/** Absolute logo URL (wallets like MetaMask need an absolute, publicly reachable image URL). */
export const tokenLogoUrl = (address, version) =>
  address ? `${window.location.origin}/api/tokens/${address}/logo${version ? `?v=${version}` : ""}` : `${window.location.origin}${LOGO_URL}`;

export const validateLogoFile = (file) => {
  if (!file) return null;
  if (!LOGO_ACCEPT.split(",").includes(file.type)) return "Logo must be a PNG, JPG or SVG image";
  if (file.size > MAX_LOGO_BYTES) return "Logo must be 512 KB or smaller";
  return null;
};

const logoMessage = (address, owner, timestamp) =>
  `FSC Hub: set logo for token ${address.toLowerCase()} as ${owner.toLowerCase()} at ${timestamp}`;

/** The token's deployer signs a short message, then the image is uploaded to FSC Hub storage. */
export async function uploadTokenLogo({ eip1193, owner, address, file }) {
  const timestamp = Math.floor(Date.now() / 1000);
  const signer = await new BrowserProvider(eip1193).getSigner();
  const signature = await signer.signMessage(logoMessage(address, owner, timestamp));
  const body = new FormData();
  body.append("file", file);
  body.append("owner", owner);
  body.append("timestamp", String(timestamp));
  body.append("signature", signature);
  return api.post(`/tokens/${address}/logo`, body).then((r) => r.data);
}

export const getPortfolio = (owner) => api.get(`/wallet/${owner}/portfolio`).then((r) => r.data);
